import React from "react";
import { Redirect } from "react-router-dom";
import {
  NumberField,
  FunctionField,
  TabbedShowLayout,
  SelectInput,
  ReferenceField,
  TextField,
  Show,
  Tab,
  ReferenceManyField,
  Datagrid,
  DateField,
  ShowButton,
  Filter,
  TextInput,
  DateInput,
  Button,
  Link,
  List,
  Pagination,
  CardActions,
  EditButton,
  GET_LIST,
  GET_ONE,
  Query,
} from "react-admin";

import {
  isEmpty,
  propEq,
  prop,
  filter,
  head,
  sum,
  map,
  path,
  isNil,
} from "ramda";
import * as R from "ramda" 
import { TextBooleanField } from "../components/TextBooleanField";
import { PersonalInformationField } from "../components/PersonalInformationField";
import CreateChargeButton from "../components/createCharge";
import moment from "moment";
import { parse } from "query-string";

import styled from "styled-components";
import moment_tz from 'moment-timezone';
import { DATEFORMAT } from "../date-config";
import {CustomizedTables} from "../components/resumenPayments"
import dataProviderFactory from "../dataProvider";
import { useState, useEffect, useMemo } from "react";
import Grid from "@material-ui/core/Grid";
import CircularProgress from '@material-ui/core/CircularProgress';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import MessageIcon from '@material-ui/icons/Message';
import PersonPin from "@material-ui/icons/PersonPin"; //vip
import Navigation from "@material-ui/icons/Navigation"; //gps
import BeachAccess from "@material-ui/icons/BeachAccess"; //cancel
import PostAddIcon from '@material-ui/icons/PostAdd'; //documents
import ProfileCompleteMark, { isDriverProfileComplete } from "../components/profileCompleteMark";


import EventSeat from "@material-ui/icons/EventSeat"; //low seat
import LocalGasStation from "@material-ui/icons/LocalGasStation"; //tankbags
import Pantool from "@material-ui/icons/PanTool"; //gloves
import Face from "@material-ui/icons/Face"; //helments
import Polymer from "@material-ui/icons/Polymer"; //jackets

import {PaymentsClients} from "../components/boxPaymentsClients"
import { canAccess } from "../rbac";
import { getCountryByID, getNationality, duration } from "../util";


import { 
  StyledExPanel, 
  ImgContainer, 
  Marker, 
  StyledTypo, 
  BorderContainer,
  StyledCard,
  LoaderContainer,
  StyledExpansionSummary,
  StyledPanelDetails,
  BordedBox,
  ClientImgContainer,
  RiderImageContainer,
  RiderHeaderTable,
  RiderTableInfo,
  IconBox,
  
} from "./styles/tourClients/style";
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import passenger_bg from "../assets/img/passenger_bg.png" ;
import rider_bg from "../assets/img/rider_bg.png" ;
import visa from "../assets/img/visa.svg" ;
import mastercard from "../assets/img/mastercard.svg" ;
import roomate_bg from "../assets/img/roomate_bg.png" ;
import vip from "../assets/img/vip.png" ;
import gps from "../assets/img/gps.png" ;
import documents from "../assets/img/documents.png" ;
import cancelation from "../assets/img/cancelation.png" ;

window.R = R

const StyledDiv = styled.div((props) => ({
  flexDirection: "column",
  alignItems: props.align ? props.align : "center",
  justifyContent: props.justify ? props.justify : "center",
  backgroundColor: props.color,
  paddingTop: props.padding ? props.padding : "0px",
  paddingBottom: props.padding ? props.padding : "0px",
  minHeight: "40px",
  display: "flex",
  minWidth: "100px",
}));

const cardActionStyle = {
  zIndex: 2,
  display: "inline-block",
  float: "right",
};
moment_tz.tz.setDefault("Europe/Madrid");
const TourClientsShowTitle = (object) => {
  const record = object && object.record;
  const booking = record && record.booking;
  const driver = record && record.driver;
  const firstName =
    (booking && booking.r_first_name) ||
    (driver && driver.client_first_name) ||
    "";
  const lastName =
    (booking && booking.r_last_name) ||
    (driver && driver.client_last_name) ||
    "";
  return (
    <span>
      {" Tour detail for Client "} &quot;
      {`${firstName} ${lastName}`.trim()}
      &quot;
    </span>
  );
};

const TourShowActions = ({ data, redirect, permissions, props }) => {
  let pendingCharges = [];

  if (data) {
    const firstPayment = head(data.payments || []);
    pendingCharges = filter(
      propEq("status", false),
      (firstPayment && firstPayment.charges) || []
    );
  }
  const from = props.location;
  let dayActual = moment(Date.now()).format("YYYY-MM-DD")
  return (
    <CardActions style={cardActionStyle}>
      <Button
        component={Link}
        to={{
          // pathname: `/tour_list`
          pathname: `/${redirect}`,
        }}
        label="Go Back"
      />
     {/*  {data && data.rental_status !== 3 &&
        canAccess("tour_due_list") && (
          <EditButton
            to={{
              pathname: `/process_tour_edit/${data.id}`,
              search: `${from.search}`,
              //search: `?from=${redirect}`,
            }}
            label="Edit"
          />
        )} */}
         {data && data.rental_status !== 3 &&
        canAccess("tour_due_list") && (
          <EditButton
            to={{
              pathname: `/process_tour_enhanced/${data.id}`,
              search: `${from.search}`,
              //search: `?from=${redirect}`,
            }}
            label="Edit"
          />
        )}
    </CardActions>
  );
};

export const TourClientsShow = ({ permissions, ...props }) => {
  const from = parse(props.location.search).from || null;
  const redirect = from ? from : "tour_list";
  const {record} = props 
  const [tourData, setTourData] = useState("")
  const [storedRecord, setStoredRecord] = useState(null)
  const [dataCountrys, setDataCountrys] = useState(null)
  const [clientCountry, setClientCountry] = useState(null)
  const [bankInfo, setBankInfo] = useState({type: "", account: ""})
  const [comments, setComments] = useState([])

  const shirtSize = { 
    1: "S (EU) | XS (US)",
    2: "M (EU) | S (US)",
    3: "L (EU) | M (US)",
    4: "XL (EU) | L (US)",
    5: "XXL (EU) | XL (US)",
    6: "XXXL (EU) | XXL (US)" 
  };
  
  const getCountrys = async () =>{
    const dataProvider = await dataProviderFactory("rest");
    const countries = await dataProvider(GET_LIST, "countries", {
      pagination: { page: 1, perPage: 1000 },
      filter: { },
      sort: { field: "country", order: "ASC" },
    })
    return countries

  }

  const getTourPrice = async (tour) =>{
    const priceDate = tour.booking.price_date
    const tour_id = tour.booking.tour_id
    const dataProvider = await dataProviderFactory("rest");
    const vehicleModels = await dataProvider(GET_LIST, "vehicle_models", {
      filter: { active: true, type: "2_2" },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "order", order: "ASC" }
    });

    const responseTourPrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        for_date: priceDate,
        for_tour_id: tour_id,
      },
      pagination: {
        page: 1,
        perPage: 99999,
      },
      sort: {}
    });
    let passengerPrice = 0
    let singlePrice = 0
    let tourTotal = 0

    if(!isNil(tour.booking.p_first_name)){
      passengerPrice = prop(
        "price",
        head(
          filter(propEq("price_item_sub_type", "tour_passenger"), responseTourPrices.data)
        )
      );
    }
    if((tour.single.length > 0) && (tour.r_single || tour.booking.r_single)){
      singlePrice = prop(
        "price",
        head(
          filter(propEq("price_item_sub_type", "tour_single"), responseTourPrices.data)
        )
      )
    }
    if (tour.vehicle.length > 0) {
      tourTotal = prop(
        "price",
        head(filter(propEq("price_item_sub_type", "tour_total"), responseTourPrices.data))
      );      
    } else {
      tourTotal = 500 + prop(
        "price",
        head(
          filter(propEq("price_item_sub_type", "tour_passenger"), responseTourPrices.data)
        )
      );
    }
    return {tourTotal, passengerPrice, singlePrice, prices: responseTourPrices, models: vehicleModels}
  }

  useEffect(() => {
    const fetchTourPrices = async () => {
      if(storedRecord){
        const result = await getTourPrice(storedRecord); 
        const countries = await getCountrys()
        setDataCountrys(countries.data)
        setTourData(result);

        setClientCountry(getCountryByID(countries.data, storedRecord.booking.r_country_id, "Not found"))
        if(storedRecord.clientData.startsWith("visa -")){
          setBankInfo({type: "visa", account: storedRecord.clientData.replace("visa -", "")})
        }else if(storedRecord.clientData.startsWith("mastercard -")){
          setBankInfo({type: "mastercard", account: storedRecord.clientData.replace("mastercard -", "")})
        }
        if(storedRecord.imt_comment){
          setComments(storedRecord.imt_comment.split('/**'))
        }
      }
    };
    
    fetchTourPrices();
  }, [storedRecord]);

const handleStoredRecord = (record) =>{
  setStoredRecord(record)
}

const renderHeightUnit = (rental) =>{
  const unitField = rental.booking.r_height_unit
  const unit = unitField === 1 || unitField === '1' ? "Ft" : "M";
  return unit;
}
const renderWeightUnit = (rental) =>{
  const unitField = rental.booking.r_weight_unit
  const unit = unitField === 1 || unitField === '1' ? "Pounds" : "Kg";
  return unit;
}

  const firstPassengerClient = head(storedRecord && storedRecord.passenger ? storedRecord.passenger : []);
  const showPassengerAccordion = Boolean(
    storedRecord &&
      ((firstPassengerClient && firstPassengerClient.client_first_name) ||
        (storedRecord.booking &&
          storedRecord.booking.p_first_name &&
          String(storedRecord.booking.p_first_name).trim() !== ""))
  );

  const passengerCountryLabel = useMemo(() => {
    if (!storedRecord || !storedRecord.booking) return clientCountry;
    if (dataCountrys && storedRecord.booking.p_country_id) {
      return getCountryByID(dataCountrys, storedRecord.booking.p_country_id, clientCountry);
    }
    return clientCountry;
  }, [storedRecord, dataCountrys, clientCountry]);

// const payload = 
  return (
    <Show
      {...props}
      title={<TourClientsShowTitle />}
      actions={
        <TourShowActions permissions={permissions} props={props} redirect={redirect} />
      }
    >
      <TabbedShowLayout>
      
        <Tab label="Tour Details">
          <FunctionField
            addLabel={false}
            render={(record) => {
              if (record && Number(record.rental_status) === 0) {
                return <Redirect to={`/process_tour_enhanced/${record.id}`} />;
              }
              handleStoredRecord(record)
            }}
          />
          {storedRecord !== null && tourData !== ""
          
          ?<Grid container spacing={24} style={{ marginTop: "10px" }}>
            <Grid item xs={4}>
              <RiderTableInfo>
                <RiderHeaderTable>
                  <Grid 
                    container
                    alignItems="center"
                    spacing={0} 
                    >
                      <Grid item xs={0}>
                        <RiderImageContainer>
                          <ClientImgContainer src={rider_bg} />
                        </RiderImageContainer>
                      </Grid>
                      <Grid item xs={0}>
                        <Grid container direction="column" spacing={0} style={{ marginTop: "10px" }}>
                          <div>
                            <StyledTypo className="pill-primary">Rider</StyledTypo>
                          </div>
                          <StyledTypo style={{textTransform: "capitalize", color:"#fff"}} className=" big">{`${storedRecord.booking.r_first_name} ${storedRecord.booking.r_last_name}`}</StyledTypo>
                          <div>
                            <StyledTypo className="pill-secondary textCapi">{`${storedRecord.booking.r_city}, ${clientCountry}`}</StyledTypo>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </RiderHeaderTable>

                <div style={{display:"block", padding:"1rem"}}>
                  <BordedBox style={{marginTop: "20px"}}>
                    <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                      <StyledTypo className="header">Full name</StyledTypo>
                      <StyledTypo className="bold">{`${storedRecord.booking.r_first_name} ${storedRecord.booking.r_last_name}`}</StyledTypo>
                    </Grid>
                  </BordedBox>
                  <BordedBox style={{marginTop: "10px"}}>
                    <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                      <StyledTypo className="header">Email</StyledTypo>
                      <StyledTypo className="bold">{`${storedRecord.booking.r_email}`}</StyledTypo>
                    </Grid>
                  </BordedBox>
                  <Grid cotainer>
                    <Grid 
                      container 
                      direction="row" 
                      justify="space-between" 
                      spacing={8} 
                      style={{ marginTop: "10px" }}
                    >
                      <Grid item xs={6}>
                        <BordedBox>
                          <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                            <StyledTypo className="header">Country</StyledTypo>
                            <StyledTypo className="bold">{`${clientCountry}`}</StyledTypo>
                          </Grid>
                        </BordedBox>
                      </Grid>
                      <Grid item xs={6}>
                        <BordedBox>
                          <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                            <StyledTypo className="header">City</StyledTypo>
                            <StyledTypo className="bold">{`${storedRecord.booking.r_city}`}</StyledTypo>
                          </Grid>
                        </BordedBox>
                      </Grid>
                    </Grid>


                    <Grid 
                      container 
                      direction="row" 
                      justify="space-between" 
                      spacing={8} 
                      style={{ marginTop: "10px" }}
                    >
                      <Grid item xs={6}>
                        <BordedBox>
                          <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                            <StyledTypo className="header">Address</StyledTypo>
                            <StyledTypo className="bold">{`${storedRecord.booking.r_address}`}</StyledTypo>
                          </Grid>
                        </BordedBox>
                      </Grid>
                      <Grid item xs={6}>
                        <BordedBox>
                          <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                            <StyledTypo className="header">ZIP code</StyledTypo>
                            <StyledTypo className="bold">{`${storedRecord.booking.r_zip}`}</StyledTypo>
                          </Grid>
                        </BordedBox>
                      </Grid>
                    </Grid>
                    <Grid 
                      container 
                      spacing={8} 
                      style={{ marginTop: "10px" }}
                    >
                      <Grid item xs={6}>
                        <BordedBox>
                          <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                            <StyledTypo className="header">Phone</StyledTypo>
                            <StyledTypo className="bold">{`${storedRecord.booking.r_home_phone || "Not found"}`}</StyledTypo>
                          </Grid>
                        </BordedBox>
                      </Grid>
                      <Grid item xs={6}>
                        <BordedBox>
                          <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                            <StyledTypo className="header">Occupation</StyledTypo>
                            <StyledTypo className="bold">{`${storedRecord.booking.r_occupation || "N/A"}`}</StyledTypo>
                          </Grid>
                        </BordedBox>
                      </Grid>
                    </Grid>

                    <Grid 
                      container 
                      direction="row" 
                      justify="space-between" 
                      spacing={8} 
                      style={{ marginTop: "10px" }}
                    >
                      <Grid item xs={6}>
                        <BordedBox>
                          <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                            <StyledTypo className="header">Passport / ID</StyledTypo>
                            <StyledTypo className="bold">{`${storedRecord.booking.r_passport}`}</StyledTypo>
                          </Grid>
                        </BordedBox>
                      </Grid>
                      <Grid item xs={6}>
                        <BordedBox>
                          <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                            <StyledTypo className="header">Nationality</StyledTypo>
                            <StyledTypo className="bold">{`${getNationality(dataCountrys, storedRecord.booking.r_nationality)}`}</StyledTypo>
                          </Grid>
                        </BordedBox>
                      </Grid>
                    </Grid>

                    <Grid 
                      container 
                      direction="row" 
                      justify="space-between" 
                      spacing={8} 
                      style={{ marginTop: "10px" }}
                    >
                      <Grid item xs={6}>
                        <BordedBox>
                          <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                            <StyledTypo className="header">Date of birth</StyledTypo>
                            <StyledTypo className="bold">{`${moment.utc(storedRecord.booking.r_birthday).format("MMMM D, YYYY")}`}</StyledTypo>
                          </Grid>
                        </BordedBox>
                      </Grid>
                      <Grid item xs={6}>
                        <BordedBox>
                          <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                            <StyledTypo className="header">Age</StyledTypo>
                            <StyledTypo className="bold">{`${moment.utc().diff(moment.utc(storedRecord.booking.r_birthday), "years")} Years old`}</StyledTypo>
                          </Grid>
                        </BordedBox>
                      </Grid>
                    </Grid>

                    <Grid 
                      container 
                      direction="row" 
                      justify="space-between" 
                      spacing={8} 
                      style={{ marginTop: "10px" }}
                    >
                      <Grid item xs={6}>
                        <BordedBox>
                          <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                            <StyledTypo className="header">Weight</StyledTypo>
                            <StyledTypo className="bold">{`${storedRecord.booking.r_weight} ${renderWeightUnit(storedRecord)}`}</StyledTypo>
                          </Grid>
                        </BordedBox>
                      </Grid>
                      <Grid item xs={6}>
                        <BordedBox>
                          <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                            <StyledTypo className="header">Height</StyledTypo>
                            <StyledTypo className="bold">{`${storedRecord.booking.r_height} ${renderHeightUnit(storedRecord)}`}</StyledTypo>
                          </Grid>
                        </BordedBox>
                      </Grid>
                    </Grid>


                    <Grid 
                      container 
                      direction="row" 
                      justify="space-between" 
                      spacing={8} 
                      style={{ marginTop: "10px" }}
                    >
                      <Grid item xs={6}>
                        <BordedBox>
                          <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                            <StyledTypo className="header">T-shirt size</StyledTypo>
                            <StyledTypo className="bold">{`${storedRecord.booking.r_shirt ? prop(storedRecord.booking.r_shirt, shirtSize) : "N/A"}`}</StyledTypo>
                          </Grid>
                        </BordedBox>
                      </Grid>
                      <Grid item xs={6}>
                        <BordedBox>
                          <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                            <StyledTypo className="header">Languages</StyledTypo>
                            <StyledTypo className="bold">{`
                            ${storedRecord.booking.r_english ? "English " : ""} 
                            ${storedRecord.booking.r_spanish ? "Spanish " : ""}
                            ${storedRecord.booking.r_german ? "German " : ""}
                            ${storedRecord.booking.r_portuguese ? "Portuguese " : ""}
                            
                            `}</StyledTypo>
                          </Grid>
                        </BordedBox>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </RiderTableInfo>
              
            </Grid>
            <Grid item xs={4} justify="space-between">
              <IconBox>
              <Grid 
                container 
                spacing={24} 
                direction="row"
                justify="center"
                style={{ marginTop: "10px" }}
              >
                <Grid item xs={0}>
                  <StyledCard className={`${isDriverProfileComplete(storedRecord) ? "available": "no-available"}`}>
                    <Grid 
                      container 
                      direction="column" 
                      justify="center"
                      alignItems="center"
                      spacing={0} 
                      style={{ marginTop: "10px" }}>
                      <ProfileCompleteMark record={storedRecord} size={28} />
                      <StyledTypo style={{textAlign:"center"}} className="bold">Profile</StyledTypo>
                    </Grid>
                  </StyledCard>
                </Grid>

                <Grid item xs={0}>
                  <StyledCard className={`${storedRecord.r_documentacion ? "available": "no-available"}`}>
                    <Grid 
                      container 
                      direction="column" 
                      justify="center"
                      alignItems="center"
                      spacing={0} 
                      style={{ marginTop: "10px" }}>
                      <PostAddIcon style={{transform: "scale(1)", }} />
                      <StyledTypo style={{textAlign:"center"}} className="bold">Docs</StyledTypo>
                      {/* <StyledTypo>{storedRecord.r_documentacion ? "Yes": "No"}</StyledTypo> */}
                    </Grid>
                  </StyledCard>
                </Grid>


                <Grid item xs={0}>
                  <StyledCard className={`${storedRecord.cancel_insurance[0] ? "available": "no-available"}`}>
                    <Grid 
                      container 
                      direction="column" 
                      justify="center"
                      alignItems="center"
                      spacing={0} 
                      style={{ marginTop: "10px" }}>
                      <BeachAccess style={{transform: "scale(1)", }} />
                      <StyledTypo style={{textAlign:"center"}} className="bold">Cancel</StyledTypo>
                      {/* <StyledTypo>{storedRecord.cancel_insurance[0] ? "Yes" : "No"}</StyledTypo> */}
                    </Grid>
                  </StyledCard>
                </Grid>


                <Grid item xs={0}>
                  <StyledCard className={`${storedRecord.insurance[0] ? "available": "no-available"}`}>
                    <Grid 
                      container 
                      direction="column" 
                      justify="center"
                      alignItems="center"
                      spacing={0} 
                      style={{ marginTop: "10px" }}>
                      <PersonPin style={{transform: "scale(1)", }}/>
                      <StyledTypo style={{textAlign:"center"}} className="bold">Vip</StyledTypo>
                      {/* <StyledTypo>{storedRecord.insurance[0] ? "Yes": "No"}</StyledTypo> */}
                    </Grid>
                  </StyledCard>
                </Grid>


                <Grid item xs={0}>
                  <StyledCard className={`${storedRecord.device[0] ? "available": "no-available"}`}>
                    <Grid 
                      container 
                      direction="column" 
                      justify="center"
                      alignItems="center"
                      spacing={0} 
                      style={{ marginTop: "10px" }}>
                      <Navigation style={{transform: "scale(1)", }}/>
                      <StyledTypo style={{textAlign:"center"}} className="bold">GPS</StyledTypo>
                      {/* <StyledTypo>{storedRecord.device[0] ? "Yes": "No"}</StyledTypo> */}
                    </Grid>
                  </StyledCard>
                </Grid>
              </Grid>
              </IconBox>
              <IconBox>
              <Grid 
                container 
                spacing={8} 
                direction="row"
                justify="space-evenly"
                style={{ marginTop: "10px" }}
              >
                <Grid item xs={0}>
                  <StyledCard className={`${storedRecord.seat[0] ? "available": "no-available"}`}>
                    <Grid 
                      container 
                      direction="column" 
                      justify="center"
                      alignItems="center"
                      spacing={0} 
                      style={{ marginTop: "10px" }}>
                      <EventSeat style={{transform: "scale(1)",}} />
                      <StyledTypo style={{textAlign:"center"}} className="bold">Low seat</StyledTypo>
                      {/* <StyledTypo>{storedRecord.r_documentacion ? "Yes": "No"}</StyledTypo> */}
                    </Grid>
                  </StyledCard>
                </Grid>


                <Grid item xs={0}>
                  <StyledCard className={`${storedRecord.tankbag[0] ? "available": "no-available"}`}>
                    <Grid 
                      container 
                      direction="column" 
                      justify="center"
                      alignItems="center"
                      spacing={0} 
                      style={{ marginTop: "10px" }}>
                      <LocalGasStation style={{transform: "scale(1)",}} />
                      <StyledTypo style={{textAlign:"center"}} className="bold">tankbags</StyledTypo>
                      {/* <StyledTypo>{storedRecord.cancel_insurance[0] ? "Yes" : "No"}</StyledTypo> */}
                    </Grid>
                  </StyledCard>
                </Grid>


                <Grid item xs={0}>
                  <StyledCard className={`${storedRecord.glove[0] ? "available": "no-available"}`}>
                    <Grid 
                      container 
                      direction="column" 
                      justify="center"
                      alignItems="center"
                      spacing={0} 
                      style={{ marginTop: "10px" }}>
                      <Pantool style={{transform: "scale(1)",}}/>
                      <StyledTypo style={{textAlign:"center"}} className="bold">gloves</StyledTypo>
                      {/* <StyledTypo>{storedRecord.insurance[0] ? "Yes": "No"}</StyledTypo> */}
                    </Grid>
                  </StyledCard>
                </Grid>


                <Grid item xs={0}>
                  <StyledCard className={`${storedRecord.helmet[0] ? "available": "no-available"}`}>
                    <Grid 
                      container 
                      direction="column" 
                      justify="center"
                      alignItems="center"
                      spacing={0} 
                      style={{ marginTop: "10px" }}>
                      <Face style={{transform: "scale(1)",}}/>
                      <StyledTypo style={{textAlign:"center"}} className="bold">Helments</StyledTypo>
                      {/* <StyledTypo>{storedRecord.device[0] ? "Yes": "No"}</StyledTypo> */}
                    </Grid>
                  </StyledCard>
                </Grid>

                <Grid item xs={0}>
                  <StyledCard className={`${storedRecord.jacket[0] ? "available": "no-available"}`}>
                    <Grid 
                      container 
                      direction="column" 
                      justify="center"
                      alignItems="center"
                      spacing={0} 
                      style={{ marginTop: "10px" }}>
                      <Polymer style={{transform: "scale(1)",}}/>
                      <StyledTypo style={{textAlign:"center"}} className="bold">Jackets</StyledTypo>
                      {/* <StyledTypo>{storedRecord.device[0] ? "Yes": "No"}</StyledTypo> */}
                    </Grid>
                  </StyledCard>
                </Grid>
              </Grid>
              </IconBox>
              {tourData !== "" ?  <PaymentsClients data={storedRecord} price={tourData} isOpen={false}/> : <CircularProgress />}
            {showPassengerAccordion && (
                <StyledExPanel>
                  <StyledExpansionSummary
                    expandIcon={<ExpandMoreIcon style={{color: "#fff"}}/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >   
                    <Grid 
                    container
                    alignItems="center"
                    spacing={0} 
                    >
                      <Grid item xs={0}>
                        <RiderImageContainer>
                            <ClientImgContainer src={passenger_bg} />
                        </RiderImageContainer>
                      </Grid>
                      <Grid item xs={0}>
                        <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                          <div>
                            <StyledTypo className="pill-primary">Passenger</StyledTypo>
                          </div>
                          <StyledTypo style={{color: "#fff"}} className="big">{`${storedRecord.booking.p_first_name} ${storedRecord.booking.p_last_name}`}</StyledTypo>
                          <div>
                            <StyledTypo className=" pill-secondary textCapi">{`${storedRecord.booking.p_city}, ${passengerCountryLabel}`}</StyledTypo>
                          </div>
                        </Grid>
                      </Grid>

                    </Grid>
                  </StyledExpansionSummary>
                  <StyledPanelDetails style={{display:"block"}}>
                    <BordedBox style={{marginTop: "20px"}}>
                      <Grid container direction="column" spacing={0} style={{ marginTop: "7px"}}>
                        <StyledTypo className="header">Full name</StyledTypo>
                        <StyledTypo className="textCapi bold">{`${storedRecord.booking.p_first_name} ${storedRecord.booking.p_last_name}`}</StyledTypo>
                      </Grid>
                    </BordedBox>
                    <BordedBox style={{marginTop: "10px"}}>
                      <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                        <StyledTypo className="header">Email</StyledTypo>
                        <StyledTypo className="bold">{`${storedRecord.booking.p_email}`}</StyledTypo>
                      </Grid>
                    </BordedBox>
                    
                    <Grid cotainer>

                      <Grid 
                        container 
                        direction="row" 
                        justify="space-between" 
                        spacing={8} 
                        style={{ marginTop: "10px" }}
                      >
                        <Grid item xs={6}>
                          <BordedBox>
                            <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                              <StyledTypo className="header">Country</StyledTypo>
                              <StyledTypo className="bold">{`${passengerCountryLabel}`}</StyledTypo>
                            </Grid>
                          </BordedBox>
                        </Grid>
                        <Grid item xs={6}>
                          <BordedBox>
                            <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                              <StyledTypo className="header">City</StyledTypo>
                              <StyledTypo className="bold">{`${storedRecord.booking.p_city}`}</StyledTypo>
                            </Grid>
                          </BordedBox>
                        </Grid>
                      </Grid>
                      <Grid 
                        container 
                        direction="row" 
                        justify="space-between" 
                        spacing={8} 
                        style={{ marginTop: "10px" }}
                      >
                        <Grid item xs={6}>
                          <BordedBox>
                            <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                              <StyledTypo className="header">Address</StyledTypo>
                              <StyledTypo className="bold">{`${storedRecord.booking.p_address}`}</StyledTypo>
                            </Grid>
                          </BordedBox>
                        </Grid>
                        <Grid item xs={6}>
                          <BordedBox>
                            <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                              <StyledTypo className="header">Nationality</StyledTypo>
                              <StyledTypo className="bold">{`${getNationality(dataCountrys, storedRecord.booking.p_nationality)}`}</StyledTypo>
                            </Grid>
                          </BordedBox>
                        </Grid>
                      </Grid>


                      <Grid 
                        container 
                        direction="row" 
                        justify="space-between" 
                        spacing={8} 
                        style={{ marginTop: "10px" }}
                      >
                        <Grid item xs={6}>
                          <BordedBox>
                            <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                              <StyledTypo className="header">Passport / ID</StyledTypo>
                              <StyledTypo className="bold">{`${storedRecord.booking.p_passport || "N/A"}`}</StyledTypo>
                            </Grid>
                          </BordedBox>
                        </Grid>
                        <Grid item xs={6}>
                          <BordedBox>
                            <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                              <StyledTypo className="header">Date of birth</StyledTypo>
                              <StyledTypo className="bold">{`${moment.utc(storedRecord.booking.p_birthday).format("MMMM D, YYYY")}`}</StyledTypo>
                            </Grid>
                          </BordedBox>
                        </Grid>
                      </Grid>


                      <Grid 
                        container 
                        direction="row" 
                        justify="space-between" 
                        spacing={8} 
                        style={{ marginTop: "10px" }}
                      >
                        <Grid item xs={6}>
                          <BordedBox>
                            <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                              <StyledTypo className="header">Age</StyledTypo>
                              <StyledTypo className="bold">{`${moment.utc().diff(moment.utc(storedRecord.booking.p_birthday), "years")} Years old`}</StyledTypo>
                            </Grid>
                          </BordedBox>
                        </Grid>
                        <Grid item xs={6}>
                          <BordedBox>
                            <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                              <StyledTypo className="header">Occupation</StyledTypo>
                              <StyledTypo className="bold">{`${storedRecord.booking.p_occupation || "N/A"}`}</StyledTypo>
                            </Grid>
                          </BordedBox>
                        </Grid>
                      </Grid>
                      <Grid 
                        container 
                        direction="row" 
                        justify="space-between" 
                        spacing={8} 
                        style={{ marginTop: "10px" }}
                      >
                        <Grid item xs={6}>
                          <BordedBox>
                            <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                              <StyledTypo className="header">Weight</StyledTypo>
                              <StyledTypo className="bold">{`${storedRecord.booking.p_weight} ${renderWeightUnit(storedRecord)}`}</StyledTypo>
                            </Grid>
                          </BordedBox>
                        </Grid>
                        <Grid item xs={6}>
                          <BordedBox>
                            <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                              <StyledTypo className="header">Height</StyledTypo>
                              <StyledTypo className="bold">{`${storedRecord.booking.p_height} ${renderHeightUnit(storedRecord)}`}</StyledTypo>
                            </Grid>
                          </BordedBox>
                        </Grid>
                      </Grid>

                      <Grid 
                        container 
                        direction="row" 
                        justify="space-between" 
                        spacing={8} 
                        style={{ marginTop: "10px" }}
                      >
                       <Grid item xs={6}>
                        <BordedBox>
                          <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                            <StyledTypo className="header">T-shirt size</StyledTypo>
                            <StyledTypo className="bold">{`${storedRecord.booking.p_shirt ? prop(storedRecord.booking.p_shirt, shirtSize) : "N/A"}`}</StyledTypo>
                          </Grid>
                        </BordedBox>
                        </Grid>
                        <Grid item xs={6}>
                          <BordedBox>
                            <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                              <StyledTypo className="header">Languages</StyledTypo>
                              <StyledTypo className="bold">{`
                              ${storedRecord.booking.p_english ? "English " : ""} 
                              ${storedRecord.booking.p_spanish ? "Spanish " : ""}
                              ${storedRecord.booking.p_german ? "German " : ""}
                              ${storedRecord.booking.p_portuguese ? "Portuguese " : ""}
                              
                              `}</StyledTypo>
                            </Grid>
                          </BordedBox>
                        </Grid>
                      </Grid>


                      <Grid 
                        container 
                        spacing={8} 
                        style={{ marginTop: "10px" }}
                      >
                        <Grid item xs={6}>
                          <BordedBox>
                            <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                              <StyledTypo className="header">Nickname</StyledTypo>
                              <StyledTypo className="bold">{`${storedRecord.booking.nickname || ""}`}</StyledTypo>
                            </Grid>
                          </BordedBox>
                        </Grid>
                        <Grid item xs={6}>
                          <BordedBox>
                            <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
                              <StyledTypo className="header">Phone</StyledTypo>
                              <StyledTypo className="bold">{`${storedRecord.booking.p_home_phone || "Not found"}`}</StyledTypo>
                            </Grid>
                          </BordedBox>
                        </Grid>
                      </Grid>
                    </Grid>
                  </StyledPanelDetails>
                </StyledExPanel>
              )}

              {(!showPassengerAccordion && storedRecord.booking && String(storedRecord.booking.roommate || "").trim() !== "") && (
                <RiderHeaderTable>
                  <Grid 
                    container
                    alignItems="center"
                    spacing={0} 
                    >
                      <Grid item xs={0}>
                        <RiderImageContainer>
                          <ClientImgContainer src={roomate_bg} />
                        </RiderImageContainer>
                      </Grid>
                      <Grid item xs={0}>
                      <Grid 
                        container
                        direction="column"
                        justify="center"

                        spacing={0} 
                        style={{ marginTop: "10px" }}
                        > <div>
                            <StyledTypo className="pill-primary">Roomate</StyledTypo>
                          </div>
                          <StyledTypo style={{color: "#fff"}} className="big">{`${storedRecord.booking.roommate}`}</StyledTypo>
                        </Grid>
                      </Grid>
                    </Grid>
                </RiderHeaderTable>
              )}
            </Grid>
            <Grid item xs={4}>
              {tourData !== "" ?  <CustomizedTables data={storedRecord} prices={tourData}/> : <CircularProgress />}
              {/* {tourData !== "" ?  <CircularProgress /> : <CircularProgress />} */}
               <RiderHeaderTable style={{ marginTop: "15px" }} className="secondary">
                  <Grid 
                    container
                    alignItems="center"
                    spacing={0} 
                    >
                      <Grid item xs={0}>
                        <RiderImageContainer className="secondary">
                          <AccountBalanceIcon  style={{transform: "scale(1.8)", color: "white"}}/>
                        </RiderImageContainer>
                      </Grid>
                      <Grid item xs={0}>
                      <Grid 
                        container
                        direction="column"
                        justify="center"

                        spacing={0} 
                        style={{ marginTop: "10px" }}
                        > <div>
                            <StyledTypo className="pill-primary">Bank information</StyledTypo>
                          </div>
                          <Grid 
                            container
                            justify="center"
                            alignItems="center"
                            spacing={0} 
                          > 
                            <img src={bankInfo.type === "visa" ? visa : mastercard} style={{width:"50px", marginRight:"10px"}}/>
                            <StyledTypo style={{color: "rgb(51,56,62)"}} className="medium">
                              {`${bankInfo.account}`}
                            </StyledTypo>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                </RiderHeaderTable>
                <RiderHeaderTable style={{ marginTop: "15px" }} className="secondary">
                  <Grid 
                    container
                    alignItems="center"
                    spacing={0} 
                    >
                      <Grid item xs={0}>
                        <RiderImageContainer className="secondary">
                          <MessageIcon style={{transform: "scale(1.8)", color: "white"}}/>
                        </RiderImageContainer>
                      </Grid>
                      <Grid item xs={0}>
                      <Grid 
                        container
                        direction="column"
                        justify="center"

                        spacing={0} 
                        style={{ marginTop: "10px" }}
                        > <div>
                            <StyledTypo className="pill-primary">Comments</StyledTypo>
                          </div>
                          {storedRecord.imt_comment !== null ? 
                            comments.map((comment) => (
                              <StyledTypo style={{color: "rgba(0, 0, 0, 0.54);", maxWidth: "390px"}} >{`${comment}`}</StyledTypo>
                            ))

                            :

                            <StyledTypo style={{color: "rgba(0, 0, 0, 0.54);"}} className="medium">no comments</StyledTypo>
                          }
                        </Grid>
                      </Grid>
                    </Grid>
                </RiderHeaderTable>
            </Grid>
          </Grid>
            
          : <LoaderContainer>
              <CircularProgress size="3.5rem" />
            </LoaderContainer>
          }
            
        </Tab>
        {/* {(prop("isAdmin", permissions) || prop("isManager", permissions)) && ( */}
        <Tab label="Payments">
          <ReferenceManyField
            label="Payments"
            reference="payments"
            target="type_id"
            filter={{ type: "rental", refund: 0 }}
          >
            <Datagrid>
              <DateField source="date" />
              <NumberField
                source="value"
                options={{ style: "currency", currency: "EUR" }}
              />
              <ShowButton label="Charges" />
              <TextField label="Comments" source="comments" />
            </Datagrid>
          </ReferenceManyField>
        </Tab>
        ){/* } */}
        {/* {(prop("isAdmin", permissions) || prop("isManager", permissions)) && ( */}
        <Tab label="Extra Payments">
          <ReferenceManyField
            label="Extra Payments"
            reference="payments"
            target="type_id"
            filter={{ type: "extra_charge", refund: 0 }}
          >
            <Datagrid>
              <DateField source="date" />
              <NumberField
                source="value"
                options={{ style: "currency", currency: "EUR" }}
              />
              <ShowButton label="Charges" />
              <TextField label="Comments" source="comments" />
            </Datagrid>
          </ReferenceManyField>
        </Tab>
        ){/* } */}
      </TabbedShowLayout>
    </Show>
  );
};

const ListPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const ViewDetailsButton = (props) => {
  const reditectTo =
    props.record.type === 1 ? "tour_clients" : "rental_clients";
  return (
    <ShowButton
      component={Link}
      to={{
        pathname: `/${reditectTo}/${props.record.id}/show`,
        search: "?from=tour_due_list",
      }}
      label="Details"
    />
  );
};

const bases = [
  { _id: 1, description: "Barcelona" },
  { _id: 2, description: "Bilbao" },
  { _id: 3, description: "Lisbon" },
  { _id: 4, description: "Madrid" },
  { _id: 5, description: "Malaga" },
  { _id: 6, description: "Santiago" },
  { _id: 8, description: "Valencia" },
];

const formatDate = date => new Date(date).toISOString().slice(0, 10);

const ToursFilter = (props) => (
  <Filter {...props}>
    <SelectInput
      label="Pick-up"
      source="location_id_1"
      choices={bases}
      optionText="description"
      optionValue="_id"
      alwaysOn
    />
    <TextInput label="Client Email" source="client_email" alwaysOn />
    <TextInput label="Client First Name" source="first_name" alwaysOn />
    <TextInput label="Client Last Name" source="last_name" alwaysOn />
    <DateInput label="Pick-up" source="date_begin" locales="es-Es" options={{ timeZone: 'UTC' }} alwaysOn />
    <DateInput label="Drop-off" source="date_end"  locales="es-Es" options={{ timeZone: 'UTC' }} alwaysOn />
  </Filter>
);

export const ToursClientsDueList = (props) => {
  return (
    <List
      {...props}
      title="Tours Due Old"
      resource="tours_due"
      filters={<ToursFilter />}
      bulkActionButtons={false}
      pagination={false}
      sort={{ field: "date_1", order: "ASC" }}
      filterDefaultValues={{ date_begin: null /* Date( )*/ }}
      filter={{ type: 1 }}
    >
      <Datagrid id="tours-due-table">
        <TextField label="Tour rental ID" source="id" />
        <TextField label="Client" source="client_name" />
        <TextField label="Tour" source="tour_name" />
        <ReferenceField
          label="P4M"
          source="booking_id"
          reference="bookings"
          linkType={false}
        >
          <TextBooleanField label="P4M" source="p4m" />
        </ReferenceField>

        <DateField
          label="Start Date"
          source="date_1"
          options={{
            year: "numeric",
            month: "numeric",
            day: "numeric",
          }}
        />
        {/* <DateField
          label="Drop-off Date"
          source="date_2"
          options={{
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric"
          }}
        /> */}
        {/* <TextField label="Vehicle" source="model_name" /> */}
        <FunctionField
          label="Pick-up city"
          addLabel={false}
          render={(r) => {
            return <StyledDiv color={r.color_1}>{r.location_name_1}</StyledDiv>;
          }}
        />
        <FunctionField
          label="Drop-off city"
          addLabel={false}
          render={(r) => {
            return <StyledDiv color={r.color_2}>{r.location_name_2}</StyledDiv>;
          }}
        />

        <ReferenceField
          label="Submitted"
          source="booking_id"
          reference="bookings"
          linkType={false}
        >
          <DateField source="r_timestamp" />
        </ReferenceField>
        <FunctionField
          label="Days to Tour"
          source="days_to_event"
          render={(rental) => {
            return `${rental.days_to_event} days`;
          }}
        />
        <NumberField
          source="rental_price"
          label="Tour Price"
          options={{
            maximumFractionDigits: 2,
            style: "currency",
            currency: "EUR",
          }}
        />
        {/* <NumberField
          source="total_payed"
          label="Total Paid"
          options={{
            maximumFractionDigits: 2,
            style: "currency",
            currency: "EUR",
          }}
        /> */}
       {/*  <NumberField
          source="due"
          options={{
            maximumFractionDigits: 2,
            style: "currency",
            currency: "EUR",
          }}
        /> */}

          <FunctionField
          label="Due" 
          render={(rental) => {
            return (
              <StyledDiv>
                { parseFloat(parseFloat(rental.due, 2) - parseFloat(rental.discount, 2)).toFixed(2) } €
              </StyledDiv>
            );
          }}
        />

        <FunctionField
          addLabel={false}
          render={(rental) => {
            return (
              <CreateChargeButton
                rental={rental}
                extraCharge={false}
                history={props}
              />
            );
          }}
        />
        <ViewDetailsButton />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/resources/tourClients.js